import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=667c5182&scoped=true"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js"
import style0 from "./SearchSuggestions.vue?vue&type=style&index=0&id=667c5182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c5182",
  null
  
)

export default component.exports